import React from "react";
import { splitDateTime } from "src/shared/components/dateTime";
import { useDateTimeFormatter } from "src/shared/configurations/hooks/useDateTimeFormatter";
import { ThemeBasedColorHeader } from "src/shared/modules/profile/theme/themeCheacker";
import { Order } from "src/shared/types";

interface Props {
  order: Order | null;
  onChangeOrder: () => void;
}

export default function OrderDetailsCard({ order, onChangeOrder }: Props) {
  const { formatDate, formatTime } = useDateTimeFormatter();
  if (!order) return null;

  const transaction = order.orders?.[0];
  const currentStatus = transaction?.status ?? "";
  const customerName = [order.customerDetails?.firstName, order.customerDetails?.middleName, order.customerDetails?.lastName].filter(Boolean).join(" ");
  const { date: orderDate, time: orderTime } = splitDateTime(order?.orderDetails[0].orderedOn.$date ?? "");

  // Single array with all row configurations
  const rows = [
    { id: "Order Id", value: order.orderId, action: onChangeOrder, showClose: true },
    { id: "Name", value: customerName },
    { id: "Status", value: currentStatus, className: "text-red-500" },
    { id: "Date", value: `${formatDate(orderDate)} / ${formatTime(orderTime)}` },
  ];

  return (
    <div className="bg-white rounded shadow">
      <div className={`${ThemeBasedColorHeader()} text-white p-2 rounded-t`}>Order Details</div>
      <div className="p-2 text-sm space-y-1">
        {rows.map(({ id, value, action, showClose, className }) => (
          <div key={id} className={`flex justify-between ${action ? "cursor-pointer" : ""}`} onClick={action}>
            <span>{id}</span>
            <span className={`flex gap-1 items-center ${className || ""}`}>
              {value}
              {showClose && <span className="text-red-500 font-bold">X</span>}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
